import {
  INIT_OPERATION,
  DISABLE_OPERATION_ACTIVE,
  ENABLE_OPERATION_ACTIVE,
  HISTORY_HOVER,
  HISTORY_CLICK,
  NEXT_STEP,
  PREVIOUS_STEP,
  SAVE,
  PREVIEW,
  SET_ACTIVE_STATU
} from "./mutation-types"

export default {
  [ENABLE_OPERATION_ACTIVE](state, { i }) {
    state.operation.children[1].children[i].isActive = true
  },
  [DISABLE_OPERATION_ACTIVE](state, { i }) {
    state.operation.children[1].children[i].isActive = false
  },
  [SET_ACTIVE_STATU](state, playload) {
    state.operation.children[2].children[playload.index].isActive = playload.statu
  }
}
